<template>
  <div v-if="item.video && !isDevices">
    <video ref="video" loop muted class="object-fit-cover">
      <source :src="item.video.src" :type="item.video.type" />
    </video>
  </div>
  <div v-else>
    <Anchor v-if="item.link" :item="item.link" :hide-text="true">
      <LazyImage
        v-if="item.image"
        :image="item.image"
        class="object-fit-cover" />
    </Anchor>
    <div v-else>
      <LazyImage
        v-if="item.image"
        :image="item.image"
        class="object-fit-cover" />
    </div>
  </div>
</template>

<script>
import * as lib from '../../lib/lib'
import jQuery from 'jquery'
import Anchor from './common/Anchor.vue'
import LazyImage from './common/LazyImage.vue'
import inViewport from 'in-viewport'

export default {
  components: { LazyImage, Anchor },
  props: {
    item: {
      required: true,
      type: Object,
    },
  },
  computed: {
    isDevices() {
      return lib.scrDevices()
    },
  },
  mounted() {
    const vid = this.$refs.video
    const height = jQuery(vid).outerHeight()

    inViewport(vid, { offset: -Number(height) }, () => {
      vid.play()
    })
  },
}
</script>
